/* eslint-disable @typescript-eslint/no-explicit-any */

import { fetchFromAPI } from "@/app/[lang]/pay-an-invoice/apiService";
import { API_CONFIG } from "@/components/form/constants";
import { PostPaymentRequestBody, PostPaymentResponse } from "@/types/payments";

export default interface UsePostPaymentUseCase {
  postPayment: (postBody: PostPaymentRequestBody) => Promise<any>;
}

export const usePostPaymentService = (): UsePostPaymentUseCase => {
  const postPayment = async (postBody: PostPaymentRequestBody): Promise<PostPaymentResponse> => {
    const body: PostPaymentRequestBody = { ...postBody };

    const headers = {
      guestpaymentkey: `${process.env.NEXT_PUBLIC_API_KEY}`,
      "Content-Type": "application/json",
    };

    return fetchFromAPI<PostPaymentResponse>({
      method: "post",
      endpoint: API_CONFIG.ENDPOINTS.payment,
      body,
      headers,
    });
  };

  return { postPayment };
};
